import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, Output } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { AiInterviewCompany, CreateCompanyPayload, CreateCompanyResponse } from '@edtech-ui/core/models/ai-interview/interview-companys';
import { AiInterviewServiceService } from '@edtech-ui/core/services/ai-interview-service/ai-interview-service.service';
import { ToastrService } from 'ngx-toastr';

@Component({
  selector: 'app-company-create-dailog',
  standalone: true,
  imports: [CommonModule, FormsModule],
  templateUrl: './company-create-dailog.component.html',
  styleUrl: './company-create-dailog.component.scss'
})
export class CompanyCreateDailogComponent {
  @Input() show = false;
  @Output() close = new EventEmitter<void>();
  @Output() companyCreated = new EventEmitter<AiInterviewCompany>();

  name = '';
  website = '';
  isSaving = false;

  constructor(
    private toast: ToastrService,
    private aiInterviewService: AiInterviewServiceService
  ) { }

  onClose() {
    this.close.emit();
  }

  onSave() {
    const name = this.name.trim();
    const website = this.website.trim(); 

    if (!name) {
      this.toast.warning('Please enter the company name.');
      return;
    }

    if (!website) {
      this.toast.warning('Please enter the company website URL.');
      return;
    }

    const payload: CreateCompanyPayload = { name, website };

    this.isSaving = true;

    this.aiInterviewService.createCompany(payload).subscribe({
      next: (res: CreateCompanyResponse) => {
        this.isSaving = false;

        if (res?.Success && res?.Data) {
          this.toast.success(res.Message || 'Company created successfully.');
          this.companyCreated.emit(res.Data);
          this.onClose();
        } else {
          this.toast.warning(res?.Message || 'Unable to create company.');
        }
      },
      error: (err) => {
        this.isSaving = false;
        this.toast.error('Failed to create company. Please try again.');
      }
    });
  }

}
